import SepableFrame from '../components/SeparableFrame';
import InfoButton from '../components/InfoButton';
import { useNavigation } from '../function/navigation';
import ShowOptions from '../function/ShowOptions';
import ValidateValue from '../function/ValidateValue';
import RenderValueComponent from './RenderValue';
import { ConvertOptionList, UnitConversion } from './UnitConversion';

function RenderInputOption({
  inputs,
  setInputs,
  options,
  setOptions,
  input_name,
  result,
  forceShowAll = false,
}) {
  const { nav } = useNavigation();

  const showAll = forceShowAll ? 'all' : nav.showOptions;

  const option = options.find((option) => option.field === input_name);

  if (option === undefined) return;

  const calculated = option.calculated;
  const value = calculated ? result[option.field] : option.value;
  const disabled = calculated || option.options?.length === 1;

  const { validateValue, warning } = ValidateValue(
    option,
    value,
    inputs,
    result
  );

  if (!ShowOptions(option, showAll) && validateValue) return;

  if (
    ['distance_flanged_plinth_below_le', 'distance_split_above_le'].includes(
      option.field
    )
  )
    return (
      <SepableFrame
        inputName={input_name}
        options={options}
        inputs={inputs}
        result={result}
        setInputs={setInputs}
        setOptions={setOptions}
      />
    );

  const name = option.name.replace(/\s*\[.*?\]\s*/g, '').trim();
  const unitMatch = option.name.match(/\[(.*?)\]/);
  const unit = unitMatch ? unitMatch[1] : '';

  const { displayedValue, displayedUnit } = UnitConversion(
    value,
    inputs.unit_system,
    unit
  );

  const convertedOptions = option.options
    ? ConvertOptionList(option.options, inputs.unit_system, unit)
    : undefined;

  const displayOption = convertedOptions
    ? { ...option, options: convertedOptions }
    : option;

  const missing =
    option.required === true &&
    [null, '', 'select an option'].includes(value) &&
    option.input !== 'checkbox';

  const problem = missing || !validateValue ? 'problem' : '';

  return (
    <div
      className={`field ${disabled ? 'disabled' : ''} ${nav.focusedInput === option.field ? 'focused' : ''} ${problem}`}
    >
      <div className="name-row">
        <div className="name">{name}</div>
        {option?.info && <InfoButton infoText={option.info} align="right" />}
      </div>
      <div className="value-unit">
        <RenderValueComponent
          inputs={inputs}
          setInputs={setInputs}
          option={displayOption}
          setOptions={setOptions}
          disabled={disabled}
          value={displayedValue}
          unit={displayedUnit}
        />
        {unit !== '' && <div className="unit">{displayedUnit}</div>}
      </div>
      {problem !== '' && (
        <div className={`input-description ${problem}`}>
          {missing ? 'input required' : warning}
        </div>
      )}
    </div>
  );
}

export default RenderInputOption;
